import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SdAccordionGroupComponent } from '../../accordion-group/accordion-group.component';
import { SdAccordionComponent } from '../../accordion-group/accordion/accordion.component';
import { IReassurancesPdp } from '../../../_interfaces/reinsurances-pdp.interface';
import { ReinsurancesPdpType } from '../../../_enums/reinsurances-pdp-type.enum';
import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdHtmlComponent } from '../../html/html.component';
import { ThemesEnum } from '../../../_enums/themes.enum';
import { IconSizeEnum } from '../../../_enums/icon.enum';

@Component({
  selector: 'sd-reinsurances-pdp',
  templateUrl: './reinsurances-pdp.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdHtmlComponent,
    TranslateModule,
    SdAccordionComponent,
    SdAccordionGroupComponent
  ]
})
export class SdReinsurancesPdpComponent extends SdThemeComponent {
  reinsurancesPdp = input<IReassurancesPdp[]>();

  isOpenedChange = output<boolean>();
  reinsurancesPdpClick = output<ReinsurancesPdpType>();

  ThemesEnum = ThemesEnum;
  PositionEnum = PositionEnum;
  IconSizeEnum = IconSizeEnum;
  isOpened = false;

  onReinsurancesPdpClick(type: ReinsurancesPdpType): void {
    this.reinsurancesPdpClick.emit(type);
  }
}
